import React from "react";
import { APP_ROUTES } from "../../../constants";
import { AppRouteMenuModel } from "../../../models";
import { VideoHomePageList, VideoResourceList } from "..";
import { VideoIcon } from "../../icons";

export const ResourceRoutes: AppRouteMenuModel[] = [
  {
    // Video Homepage
    path: APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.BASE,
    title: "Video Homepage",
    renderComponent: () => {
      return <VideoHomePageList />;
    },
    icons: {
      inactive: <VideoIcon size={[19, 16]} color="#525560" />,
      active: (
        <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.06818 1L15.4773 1C16.6195 1 17.5455 1.89543 17.5455 3V13C17.5455 14.1046 16.6195 15 15.4773 15H3.06818C1.92596 15 1 14.1046 1 13L1 3C1 1.89543 1.92596 1 3.06818 1ZM3.06818 1L5.13636 4M1 4H17.5455M13.4091 1L15.4773 4M10.3068 1L12.375 4M6.17045 1L8.23864 4M7.20455 8.61803V10.382C7.20455 11.1253 8.01353 11.6088 8.7011 11.2764L10.5252 10.3944C11.2873 10.0259 11.2873 8.9741 10.5252 8.60557L8.7011 7.72361C8.01353 7.39116 7.20455 7.87465 7.20455 8.61803Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
  },
  {
    // Videos Resource
    path: APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.BASE,
    title: "Video Resource",
    renderComponent: () => {
      return <VideoResourceList />;
    },
    icons: {
      inactive: <VideoIcon size={[19, 16]} color="#525560" />,
      active: (
        <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.06818 1L15.4773 1C16.6195 1 17.5455 1.89543 17.5455 3V13C17.5455 14.1046 16.6195 15 15.4773 15H3.06818C1.92596 15 1 14.1046 1 13L1 3C1 1.89543 1.92596 1 3.06818 1ZM3.06818 1L5.13636 4M1 4H17.5455M13.4091 1L15.4773 4M10.3068 1L12.375 4M6.17045 1L8.23864 4M7.20455 8.61803V10.382C7.20455 11.1253 8.01353 11.6088 8.7011 11.2764L10.5252 10.3944C11.2873 10.0259 11.2873 8.9741 10.5252 8.60557L8.7011 7.72361C8.01353 7.39116 7.20455 7.87465 7.20455 8.61803Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
    },
  },
];
